module.exports = __webpack_public_path__ + "img/qr_user.51ab3b94.svg";